import Label from '../../shared/styledComponents/Label';
import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';

export default InjectedStyledComponent(Label, 'selectionField', ['label']);